import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainPage from "./components/MainPage";
import RequireAuth from './auth/RequireAuth';
import AdminHome from './pages/admin/AdminHome';
import AdminLogin from './pages/admin/AdminLogin';
import Unsubscribe from './pages/Unsubscribe';

const App = () => {
  const adminBase = process.env.REACT_APP_ADMIN_BASE || '/admin';
  return (
    <BrowserRouter>
      <Routes>
        {/* Public site */}
        <Route exact path='/' element={<MainPage />} />
       
        {/* Public unsubscribe page */}
        <Route path='/unsubscribe' element={<Unsubscribe />} />
        
        {/* Auth0 callback */}
        <Route path={`${adminBase}/login`} element={<AdminLogin />} />

        {/* Auto-redirect to Auth0 if not logged in */}
        <Route
          path={adminBase}
          element={
            <RequireAuth>
              <AdminHome />
            </RequireAuth>
          }
        />

        <Route path='*' element={<h2>Page not found!</h2>} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
